import { Icon24SkipOneBackward } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const StepBackFrameIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M12.8572 4.30167V12.8731"
        stroke="currentColor"
        strokeWidth="0.964286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7143 4.82713V12.3472C10.7135 12.4419 10.6873 12.5346 10.6385 12.6158C10.5897 12.6969 10.52 12.7635 10.4367 12.8085C10.3534 12.8536 10.2596 12.8755 10.165 12.872C10.0704 12.8685 9.97841 12.8396 9.89871 12.7885L3.99313 9.02847C3.91872 8.98136 3.85743 8.91619 3.81496 8.83904C3.7725 8.76189 3.75023 8.67525 3.75023 8.58718C3.75023 8.49911 3.7725 8.41247 3.81496 8.33532C3.85743 8.25816 3.91872 8.193 3.99313 8.14588L9.89871 4.38584C9.97841 4.33472 10.0704 4.3059 10.165 4.30238C10.2596 4.29886 10.3534 4.32078 10.4367 4.36583C10.52 4.41089 10.5897 4.47745 10.6385 4.55858C10.6873 4.63971 10.7135 4.73245 10.7143 4.82713Z"
        stroke="currentColor"
        strokeWidth="0.964286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StepBackFrameIcon = fplIcon(StepBackFrameIconLocal, Icon24SkipOneBackward);
